module.exports = __webpack_public_path__ + "static/media/Twitter.54349af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/referral/Twitter.png
// module id = 1380
// module chunks = 0